import ProductListPage from "../../components/blocks/ProductListPage/ProductListPage";
import MetaElement from "../../components/elements/MetaElement";
import StructuredData from "../../components/elements/StructuredDataElement";
import { cardListItems } from "../../utils/seoItems";
import { activeCardGames, singlesListingProps } from "../../utils/singlesListing";

// Maps a slug to the MetaElement page id so each game keeps its hand-tuned
// SEO copy. Slugs not in this map fall back to the generic `singles` block.
const SLUG_TO_META = {
  "magic-the-gathering": "mtg-singles",
  "yu-gi-oh": "ygo-singles",
  "pokemon": "pkm-singles",
  "one-piece": "op-singles",
  "star-wars-unlimited": "swu-singles",
  "flesh-and-blood": "fab-singles",
  "riftbound": "riftbound-singles",
};

const SinglesGame = (props) => {
  const gameName = props.gameName || "TCG";
  return (
    <>
      <MetaElement pageId={SLUG_TO_META[props.gameSlug] || "singles"} />
      <StructuredData
        type="ItemList"
        name={`Singles ${gameName}`}
        items={cardListItems(props.products)}
      />
      <ProductListPage
        {...props}
        view="singles"
        key={props.gameSlug}
        game={props.gameId}
      />
    </>
  );
};

SinglesGame.getInitialProps = async function (ctx) {
  const gameSlug = ctx.query.gameSlug;

  // Resolve slug → local CardGame.id; the Typesense `game` field stamps
  // the local primary key so the filter is index-agnostic.
  let gameId = null;
  let gameName = null;
  let activeGames = [];
  try {
    const response = await activeCardGames(ctx);
    const games = (response && response.data) || [];
    activeGames = games;
    const match = games.find((g) => g.slug === gameSlug);
    if (match) {
      gameId = match.id;
      gameName = match.name;
    }
  } catch (e) {
    gameId = null;
  }

  if (!gameId) {
    if (ctx.res) {
      ctx.res.writeHead(302, { Location: "/singles" });
      ctx.res.end();
    }
    return { gameSlug };
  }

  const gameBreadcrumb = {
    label: gameName,
    type: "game",
    as: `/singles/${gameSlug}`,
    href: `/singles/${gameSlug}`,
  };

  const response = await singlesListingProps(ctx, gameId);

  return {
    ...response,
    gameSlug,
    gameId,
    gameName,
    activeGames,
    breadcrumbs: [gameBreadcrumb],
  };
};

export default SinglesGame;
